/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import FR2052AAuditLog from '../components/FR2052AAuditLog';

const FR2052AAuditLogs = ({ data }) => {
    const fr2052aColumns = AuditLogsColumnConfig;

    return (
        <FR2052AAuditLog
            data={data}
            columns={fr2052aColumns}
        />
    );
};
export default FR2052AAuditLogs;
